var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallMicOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666016 0.666992L7.99935 8.00033L15.3327 15.3337",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.22705V2.66705C10.0005 2.17107 9.81669 1.6926 9.48425 1.32452C9.15181 0.95644 8.69447 0.725015 8.201 0.675169C7.70753 0.625324 7.21314 0.760615 6.81381 1.05478C6.41448 1.34894 6.1387 1.78099 6.04 2.26705M6 6.00039V8.00039C6.00035 8.39569 6.11783 8.78203 6.33762 9.11061C6.55741 9.43918 6.86964 9.69526 7.23487 9.84649C7.60011 9.99772 8.00197 10.0373 8.3897 9.9603C8.77743 9.88327 9.13364 9.69307 9.41333 9.41372L6 6.00039Z",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3341 11.3003C10.6833 11.9646 9.84886 12.4193 8.93785 12.6061C8.02683 12.7928 7.0808 12.7031 6.22111 12.3485C5.36142 11.9939 4.62728 11.3905 4.11289 10.6158C3.5985 9.84102 3.32731 8.93026 3.33411 8.00033V6.66699M12.6674 6.66699V8.00033C12.6672 8.27529 12.6427 8.54969 12.5941 8.82033",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.667V15.3337",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 15.333H10.6673",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallMicOff);
export default __webpack_public_path__ + "static/media/SmallMicOff.2a3d2f78a4fb6f0a7b85928719cab580.svg";
export { ForwardRef as ReactComponent };